import { Shimmer, ShimmerLoader } from "../../../../components/common/shimmer";
import { SectionCard } from "../../../../components/common/section-card";

export function SellerDashboardSkeleton() {
  return (
    <ShimmerLoader message="Loading dashboard…" className="flex w-full flex-col gap-6 px-8 py-8">
      <div className="flex flex-col gap-6">
        <Shimmer className="h-9 w-52" />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <StatSkeleton key={`stat-a-${i}`} />
          ))}
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <StatSkeleton key={`stat-b-${i}`} />
          ))}
        </div>

        <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
          <SectionSkeleton titleWidth="w-40" actionWidth="w-24" rowCount={2} rowKind="preview" />
          <SectionSkeleton titleWidth="w-52" actionWidth="w-20" rowCount={4} rowKind="pill" />
          <SectionSkeleton titleWidth="w-48" actionWidth="w-24" rowCount={3} rowKind="preview" />
          <SectionSkeleton titleWidth="w-44" actionWidth="w-24" rowCount={3} rowKind="pill" />
        </div>

        <SectionSkeleton titleWidth="w-56" actionWidth="w-24" rowCount={4} rowKind="preview" />
      </div>
    </ShimmerLoader>
  );
}

function StatSkeleton() {
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-borderDefault bg-bgWhite px-6 py-8 shadow-[0px_2px_12px_0px_rgba(190,189,217,0.2)]">
      <Shimmer className="size-12 rounded-full" />
      <div className="flex min-w-0 flex-1 flex-col gap-3">
        <Shimmer className="h-4 w-28" />
        <Shimmer className="h-8 w-20" />
        <Shimmer className="h-3 w-24" />
      </div>
    </div>
  );
}

function SectionSkeleton({
  titleWidth,
  actionWidth,
  rowCount,
  rowKind,
}: {
  titleWidth: string;
  actionWidth: string;
  rowCount: number;
  rowKind: "preview" | "pill";
}) {
  return (
    <SectionCard
      shadow
      title={<Shimmer className={`h-6 ${titleWidth}`} />}
      action={<Shimmer className={`h-9 rounded-lg ${actionWidth}`} />}
    >
      <div className="flex flex-col gap-3">
        {Array.from({ length: rowCount }).map((_, i) =>
          rowKind === "preview" ? (
            <div
              key={`preview-${i}`}
              className="flex items-center gap-3 rounded-2xl border border-borderDefault bg-bgWhite px-4 py-3"
            >
              <Shimmer className="size-12 rounded-xl" />
              <div className="flex min-w-0 flex-1 flex-col gap-2">
                <Shimmer className={`h-4 ${i % 2 === 0 ? "w-56" : "w-44"}`} />
                <Shimmer className={`h-3 ${i % 2 === 0 ? "w-36" : "w-28"}`} />
                <div className="flex items-center justify-between gap-3">
                  <Shimmer className={`h-4 ${i % 2 === 0 ? "w-24" : "w-20"}`} />
                  <Shimmer className={`h-4 ${i % 2 === 0 ? "w-28" : "w-24"}`} />
                </div>
              </div>
            </div>
          ) : (
            <div
              key={`pill-${i}`}
              className="flex items-center gap-4 rounded-2xl border border-borderDefault bg-bgWhite px-4 py-3"
            >
              <Shimmer className="size-12 rounded-xl" />
              <div className="flex min-w-0 flex-1 flex-col gap-2">
                <Shimmer className={`h-4 ${i % 2 === 0 ? "w-48" : "w-40"}`} />
                <Shimmer className={`h-3 ${i % 2 === 0 ? "w-32" : "w-24"}`} />
              </div>
              <Shimmer className="h-6 w-24 rounded-full" />
            </div>
          ),
        )}
      </div>
    </SectionCard>
  );
}
